import { Flex, Spinner } from '@npco/zeller-design-system'
import { indexOf } from 'ramda'

import {
  StyledContent,
  StyledLogo,
  StyledText,
  StyledTextWrapper,
} from 'pages/Login/LoadingPage.styled'
import { StyledWrapper } from 'layouts/AuthLayout/AuthLayout.styled'

interface Props {
  children?: React.ReactNode[]
}

export const AuthLoadingPage = ({ children }: Props) => (
  <StyledWrapper>
    <StyledLogo />
    <Flex height="100%">
      <StyledContent>
        <Spinner dataTestId="loader" />
        <StyledTextWrapper>
          {children?.map((element) => (
            <StyledText key={`loading-copy-${indexOf(element, children)}`}>
              {element}
            </StyledText>
          ))}
        </StyledTextWrapper>
      </StyledContent>
    </Flex>
  </StyledWrapper>
)
